import { logger } from '@/services/logger/logger.client'

type ConsentStatus = 'granted' | 'denied'

export type OneTrustConsentGroups = {
  required: ConsentStatus
  performance: ConsentStatus
  functional: ConsentStatus
  targeting: ConsentStatus
  social: ConsentStatus
}

export function parseOneTrustConsentGroups(): OneTrustConsentGroups | null {
  const activeGroups = (window as unknown as Window & { OnetrustActiveGroups: string }).OnetrustActiveGroups
  if (typeof activeGroups !== 'string') {
    logger.warn('Failed to read window.OnetrustActiveGroups')
    return null
  }
  return {
    required: 'granted',
    performance: activeGroups.includes(',C0002,') ? 'granted' : 'denied',
    functional: activeGroups.includes(',C0003,') ? 'granted' : 'denied',
    targeting: activeGroups.includes(',C0004,') ? 'granted' : 'denied',
    social: activeGroups.includes(',C0005,') ? 'granted' : 'denied',
  }
}
